import React from 'react'
import { Row, Col } from 'react-bootstrap'
import i18next from 'i18next'
import GridContainer from './GridContainer'
import Error from './smart/ErrorContainer'
import Loading from './Loading'

import supportService from '../services/support'
import { availableLanguages } from './../assets/translations/availableLanguages'

import illustration from '../assets/images/wopi-clipped-puzzle.png'
import document from '../assets/images/document.svg'

import adminStyles from './styles/admin.scss'
import supportStyles from './styles/support.scss'

export default class SupportPage extends React.Component {
  constructor(props) {
    super(props)

    i18next.loadLanguages(props.language, () => {
      this.state = {
        language: props.language,
        files: [],
        isLoading: false
      }
    })
  }

  componentDidMount() {
    this.loadAvailableFiles(this.props.language)
  }

  loadAvailableFiles = language => {
    this.setState({ isLoading: true })

    supportService
      .getAvailableFiles(language)
      .then(x => {
        this.setState({ files: x.data, isLoading: false })
      })
      .catch(err => {
        this.setState({ isLoading: false })
        this.props.setError('support_page_error')
      })
  }

  changeLanguage = language => {
    this.setState({ language })
    this.loadAvailableFiles(language)
  }

  renderLoading = () => {
    return <Loading inline />
  }

  displayName = filename => {
    return filename.replace(/\.[^.]+$/, '')
  }

  renderMaterials = () => {
    return (
      <Col sm={9}>
        <Row>
          <Col sm={12} className={supportStyles.materialList}>
            {this.state.files.map((filename, key) => (
              <Col sm={6} md={6} lg={4} key={key}>
                <a
                  href={`/api/support/download/${this.state.language}/${filename}`}
                  className={supportStyles.material}
                >
                  <div>
                    <img src={document} />

                    <h3>{this.displayName(filename)}</h3>
                  </div>
                </a>
              </Col>
            ))}
          </Col>
        </Row>
      </Col>
    )
  }

  render() {
    if (this.props.hasError) {
      return (
        <GridContainer>
          <Error />
        </GridContainer>
      )
    }

    return (
      <GridContainer>
        <Row>
          <Col md={12}>
            <div className={adminStyles.customerService}>
              <Row>
                <Col sm={8}>
                  <div style={{ padding: '0 20px' }}>
                    <h1>{i18next.t('customer_service')}</h1>

                    <p>{i18next.t('customer_service_description')}</p>

                    <br />

                    <h3>{i18next.t('customer_service_number_text')}</h3>
                    <h3>{i18next.t('customer_service_email_text')}</h3>
                  </div>
                </Col>

                <Col sm={4} style={{ textAlign: 'right' }}>
                  <img src={illustration} />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <div>
          <Row>
            <Col sm={3} className={supportStyles.languages}>
              <ul>
                {availableLanguages.map(l => (
                  <li
                    key={l.key}
                    className={l.key === this.state.language && supportStyles.selected}
                  >
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault()
                        i18next.loadLanguages(l.key, () => this.changeLanguage(l.key))
                      }}
                    >
                      {i18next.t(l.translationKey)}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
            {this.state.isLoading ? this.renderLoading() : this.renderMaterials()}
          </Row>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupportPage.js